import React from 'react'

import styles from './NewsEvents.module.scss'

export const Facebook = () => {
  return (
    <iframe className={styles.Facebook} src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fpg%2Fcayafreedom%2F&tabs=timeline%2Cevents%2Cmessages&width=320&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=275341442519650" width="320" height="500" title="Facebook" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
  )
}
